import { AvatarGroup } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "UserChip";

export const classes = {
  root: `${PREFIX}-root`,
  disabled: `${PREFIX}-disabled`,
};

export const UserChipStyled = styled(AvatarGroup)(({ theme }) => ({
  [`&.${classes.root}`]: {
    gap: theme.spacing(1),
    justifyContent: "start",
    "& .MuiAvatarGroup-avatar": {
      ...theme.typography.body1,
      backgroundColor: theme.palette.primary.main,
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: 0,
      border: 0,
    },
  },
  [`&.${classes.disabled}`]: {
    "& .MuiAvatarGroup-avatar": {
      backgroundColor: `${theme.palette.gray.dark} !important`,
    },
  },
}));
